import {logError} from "../../../utils/loggerHelpers";
import type {EnsAlertSummary, PageResponse} from "../../../store/features/ens/types";

export const ENS_EXPORT_PAGE_SIZE = 100;
export const ENS_EXPORT_MAX_PAGES = 50;

export type FetchAlertPage = (paging: {offset: number; limit: number}) => Promise<PageResponse<EnsAlertSummary>>;

export const fetchAllAlertPages = async (fetchPage: FetchAlertPage): Promise<EnsAlertSummary[]> => {
    const alerts: EnsAlertSummary[] = [];
    let totalCount = 0;
    let fetchedPages = 0;

    for (let page = 0; page < ENS_EXPORT_MAX_PAGES; page += 1) {
        const result = await fetchPage({offset: page * ENS_EXPORT_PAGE_SIZE, limit: ENS_EXPORT_PAGE_SIZE});
        alerts.push(...result.data);
        totalCount = result.totalCount;
        fetchedPages += 1;

        if (result.data.length === 0 || alerts.length >= totalCount) {
            break;
        }
    }

    if (fetchedPages >= ENS_EXPORT_MAX_PAGES && alerts.length < totalCount) {
        logError('ENS alert export truncated at page cap', {
            source: 'api',
            event: 'export_page_cap_reached',
        });
    }

    return alerts;
};
